import FieldLabel from "./FieldLabel";
import Wave from "../../components/symbols/Wave";

function Boxed(props) {
  const { style, children } = props || {};

  return (
    <div
      style={{
        display: `inline-block`,
        padding: `0.15rem 0.3rem`,
        color: `rgb(255 255 255 / 1)`,
        backgroundColor: `rgb(0 0 0 / 1)`,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export default function Project(props) {
  const {
    theme,
    title,
    year,
    agency,
    link,
    linkLabel,
    comments,
    video = null
  } = props || {};
  const {
    color,
  } = theme || {};

  const titleParts = title.split(' ');

  return (
    <div
      style={{
        position: 'relative',
        transformStyle: 'preserve-3d',
        perspective: '700px',
      }}
    >
      <div
        style={{
          position: 'relative',
          width: '100%',
          maxWidth: '750px',
          margin: '1rem auto',
          padding: '0.25rem 1rem',
        }}
      >


        <div
          style={{
            position: 'absolute',
            zIndex: 1,
            top: 0,
            left: '50%',
            borderRadius: '50%',
            width: '150%',
            transformOrigin: 'center 0',
            transform: `
              translate(-50%, 5%)
            `,
            pointerEvents: 'none',
          }}
        >
          <Wave
            style={{
              width: '100%',
              height: '100%',
            }}
            strokeWidth="4rem"
            stroke={color}
            angularVelocity={0.00025}
            segments={128}
          />
        </div>


        {title ? <h2
          style={{
            position: 'relative',
            zIndex: 4,
            textTransform: `uppercase`,
            transform: `rotate(-7deg) translateX(-1rem)`,
            fontSize: '2.5rem',
            fontFamily: '"Blackout", sans-serif',
            lineHeight: 1,
          }}
        >
          {titleParts.map( (tp, i) => {
            return (
              <div
                key={tp}
                style={{
                  marginLeft: `${i * 2}rem`,
                }}
              >
                <Boxed>
                  {tp}
                </Boxed>
              </div>
            );
          })}
        </h2> : null}

        <div
          style={{
            position: 'relative',
            zIndex: 3,
            textAlign: 'right',
            transform: `rotate(4deg)`,
            transformOrigin: `100% 100%`,
          }}
        >
          {year ? <h3
            style={{
              marginBottom: 0,
              fontFamily: '"Blackout", sans-serif',
            }}
          >
            <small
              style={{
                fontStyle: `italic`,
              }}
            >
              in&nbsp;
            </small>
            <Boxed>
              {year}
            </Boxed>
          </h3> : null}

          {agency ? (
            <h3
              style={{
                marginTop: `0.1rem`,
                marginRight: `1rem`,
                fontFamily: '"Blackout", sans-serif',
              }}
            >
              <small
                style={{
                  fontStyle: `italic`,
                }}
              >
                with&nbsp;
              </small>
              <Boxed>
                {agency}
              </Boxed>
            </h3>
          ): null}
        </div>

        {link ? (
          <div
            style={{
              // TODO
              display: 'none',
            }}
          >
            <FieldLabel>Link</FieldLabel>
            <a
              style={{
              }}
              href={link}
              rel="noreferrer noopener"
              target="_blank"
            >
              {linkLabel ? linkLabel : link}
            </a>
          </div>
        ): null}

        {video !== null ? (
          <div
            style={{
              position: 'relative',
              zIndex: 3,
              maxWidth: '750px',
              transform: `translateX(-1rem)`,
            }}
          >

            <div
              style={{
                position: 'relative',
                overflow: 'hidden',
              }}
            >

              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox={`0 0 16 9`}
                style={{
                  width: '100%',
                  height: '100%',
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  zIndex: 3,
                  top: 0,
                  left: 0,
                  overflow: 'hidden',
                }}
              >
                <video
                  style={{
                    width: '100%',
                    height: '100%',
                    display: 'block',
                  }}
                  muted
                  autoPlay
                  loop
                  playsInline
                >
                  <source
                    src={video}
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>
          </div>
        ): null}
      </div>

      <div
        style={{
          position: 'relative',
          zIndex: 3,
          width: '100%',
          maxWidth: '600px',
          margin: '0 auto 2rem',
          padding: '0.25rem 0',
          lineHeight: 1.5,
          overflow: 'hidden',
        }}
      >
        {comments
          ? (
            <div
              style={{
                position: 'relative',
                zIndex: 1,
              }}
            >
              {comments.map((c, i) => {
                const { id, content } = c || {};

                // componentize further!
                return (
                  <div
                    key={id}
                    style={{
                      marginTop: '1rem',
                      fontSize: '1.25rem',
                    }}
                  >
                    <Boxed
                      style={{
                        position: 'relative',
                        marginLeft: i % 2 === 0 ? '10%' : 0,
                        marginRight: i % 2 === 0 ? 0 : '10%',
                        padding: '0.75rem',
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox={`0 0 100 100`}
                        style={{
                          overflow: 'visible',
                          width: '2rem',
                          height: '0.9rem',
                          position: 'absolute',
                          left: '50%',
                          top: 0,
                          transform: `
                            translate(-50%, -100%)
                          `,
                        }}
                        preserveAspectRatio="none"
                      >
                        <path
                          d={`
                            M 0,100
                            C 50,100, 50,0, 50,0
                            C 50,0, 50,100, 100,100
                          `}
                        />
                      </svg>

                      <p style={{ margin: 0 }}>
                        {content}
                      </p>
                    </Boxed>
                  </div>
                );
              })}
            </div>
          ): null
        }
      </div>
    </div>
  );
}


